import { MedicineDetails, MedicineDetailsQuery, MedicineSimple } from '@dreryk/drerykweb-medicine-api';

import { useCqrsGet, UseCqrsQueryResult } from '@dreryk/command-query-react-common';

export const useMedicineDetailsQuery = (medicineId: MedicineSimple['id']): UseCqrsQueryResult<MedicineDetails> => {
   return useCqrsGet(() => {
      const query = new MedicineDetailsQuery();
      query.medicineId = medicineId;
      return query;
   });
};
